import { Injectable } from '@angular/core';
import {Socket} from 'socket.io-client';
import * as io from 'socket.io-client'
import { Observable, BehaviorSubject, observable ,Subject} from 'rxjs';
import { UrlModal } from '../url.model';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SocketsService {
  socket:Socket;
  id: any;
  appnumSubject = new BehaviorSubject<any>(null)
  private subject= new  Subject<any>();

  constructor(private authService: AuthService) {
    this.authService.authDataSubject.pipe(take(1)).subscribe((res:any) => {
      this.id = res._id;
    });
    this.socket = io.connect(UrlModal._URL,{query:{foo:this.id}});
    this.socket.io.on(SocketEvent.ERROR, (error) => {
      console.warn("this is socket error",error);
      
    });
    this.socket.on("reconnect_error", () => {
      console.warn(this.socket.id); // "G5p5..."
    });
    this.socket.on("reconnect",(res)=>{
      console.warn("this socket response to disconnect",res);
      
    })
    this.socket.on("reconnect_failed",(res)=>{
      console.warn("this socket response to disconnect",res);
      
    })
    this.socket.on("connection",(res)=>{
      console.warn("this socket response to connected ",res);
    })
  }
  onEmergencyAppointment(){
    return Observable.create(observer => {
      this.socket.on('emergencyappointment')
    })
  }
  onNewAppointmentMessage() {
    return Observable.create(observer => {
      this.socket.on('appointmentStatus', data => {
        // console.log("this is lateAppointment data",data);
        if (data.action === 'newappointment') {
          observer.next(data);
          console.log("this is lateAppointment data" , data);
          return data;
        }
        if (data.action === 'lateappointment') {
          observer.next(data);
          return data;
        }
        else {
          observer.next(null);
        }
      });
    });
  }

  onLateAppointmentMessage() {
    return Observable.create(observer => {
      this.socket.on('lateAppointment', data => {
        if (data.action === 'lateappointment') {
          observer.next(data.appointment);
        }
        else {
          observer.next(null);
        }
      });
    });
  }
  sendprofileupdate(){
    this.subject.next();
  }
  recieveprofileupdate():Observable<any>{
    return this.subject.asObservable();

  }
}
export enum SocketEvent {
  CONNECT = "connect",
  DISCONNECT = "disconnect",
  RECONNECT = "reconnect",
  ERROR = "error"
}